interface IMyleObjectType {
    getMyleObjectType()
}

enum MyleObjectType {
    None,
    Prescription,
    ConsultationRequest,
    ExamRequest,
    Result,
    CommunicationHistory,
    PrivateBill,
    Document,
    MedicalNoteForm,
    CnesstForm,
    ObstetricalFile,
    WorkSafeBc,
    GrowthCharts
}

export { IMyleObjectType, MyleObjectType };
